import 'mlmi-library'
import Burger from 'mlmi-library/components/burger/v1/burger'
import Mobile from 'mlmi-library/modules/mobile/v1/mobile'
import Navigation from 'mlmi-library/modules/navigation/v1/navigation'
import Viewport from 'mlmi-library/components/viewport/v1/viewport'
import { CoreDetect_WebP } from 'mlmi-library/utils/device'
import 'mlmi-library/components/fade-in/v1/fade-in'
import { TRANSITION_END } from 'mlmi-library/utils/animation'
import 'jquery.easing'

export { Burger, Mobile, Navigation, Viewport, TRANSITION_END }

CoreDetect_WebP()
